import * as theme from '../theme'

/**
 * Returns an object with colors depening on child order
 * @param order : number
 * @return {{color: string, bg: string}}
 */
export const getColorsFromOrder = order => {
   switch (order) {
      case 1:
         return {
            color: theme.color.complement1,
            bg: theme.color.complement1Light
         }
      case 2:
         return {
            color: theme.color.complement2,
            bg: theme.color.complement2Light
         }
      case 3:
         return {
            color: theme.color.complement3,
            bg: theme.color.complement3Light
         }
      case 4:
         return {
            color: theme.color.complement4,
            bg: theme.color.complement4Light
         }
      default:
         return {
            color: theme.color.complement1,
            bg: theme.color.complement1Light
         }
   }
}
